import React from 'react'
import { useStyles } from './styles'
import { FormProvider, useForm, useFormContext } from 'react-hook-form'
import { InputCheck, Button } from 'src/components'
import { PageTitle } from 'src/components/PageTitle'
import { MovimentationForm, movimentationSchema } from 'src/@types/validations/Animal'
import { yupResolver } from '@hookform/resolvers/yup'

import { AnimalMovimentation } from './AnimalMovimentation'
import { LoteMovimentation } from './LoteMovimentation'
import { useMovimentation } from './hooks/useMovimentation'
import { useGetLotList } from 'src/hooks/api/lot'
import { useGetPastureList } from 'src/hooks/api/pasture'

export const Movimentation: React.FC = () => {
  const methods = useForm<MovimentationForm>({
    resolver: yupResolver(movimentationSchema),
    defaultValues: {
      tipoMovimentacao: 'animal',
      idAnimal: '',
      loteOrigem: '',
      loteDestino: '',
      pastoOrigem: '',
      pastoDestino: ''
    }
  })

  return (
    <FormProvider {...methods}>
      <WeighingComponent />
    </FormProvider>
  )
}

const WeighingComponent: React.FC = () => {
  const styles = useStyles()

  const {
    watch,
    reset,
    formState: { errors },
    register,
    handleSubmit
  } = useFormContext<MovimentationForm>()

  const { onSubmit, isSaving } = useMovimentation()

  const { data: lotList = [] } = useGetLotList()
  const { data: pastureList = [] } = useGetPastureList()

  const movimentationType = watch('tipoMovimentacao')

  return (
    <>
      <PageTitle title='Movimentação' />

      <form onSubmit={handleSubmit(onSubmit)}>
        <section className={styles.section}>
          <div className={styles.checkInputContainer}>
            <InputCheck
              id='movimentation-animal'
              value='animal'
              label='Animal'
              checked={watch('tipoMovimentacao') === 'animal'}
              register={register}
              error={errors?.tipoMovimentacao?.message}
              onChange={(e) => {
                const value = e.target.value
                reset({ tipoMovimentacao: value })
              }}
            />

            <InputCheck
              id='movimentation-lote'
              value='lote'
              label='Lote'
              checked={watch('tipoMovimentacao') === 'lote'}
              register={register}
              onChange={(e) => {
                const value = e.target.value
                reset({ tipoMovimentacao: value })
              }}
            />
          </div>

          <div style={{ marginTop: 16 }}>
            {movimentationType === 'animal' && <AnimalMovimentation lotList={lotList} pastureList={pastureList} />}
            {movimentationType === 'lote' && (
              <LoteMovimentation lotList={lotList} pastureList={pastureList} isSaving={isSaving} />
            )}
          </div>
        </section>

        <div className={styles.formActions}>
          <Button className={styles.buttonWrapper} type='submit' disabled={isSaving} isLoading={isSaving}>
            Salvar
          </Button>
        </div>
      </form>
    </>
  )
}
